var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-livetalk-header"},[_c('h1',[_vm._v("홈앤 &tok")]),_c('clock',{ref:"remainClock",attrs:{"startTime":_vm.startTime,"endTime":_vm.endTime}}),_c('a',{staticClass:"btn-close",attrs:{"href":"hnsmallapp://webcontrol?action=typeViewClose"}},[_vm._v("X")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }